// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.ICIntegrationBanner {\n    width: 100%;\n    background-color: black;\n    text-align: center;\n    margin-bottom: 1em;\n}\n\ndiv.ICIntegrationBanner h3 {\n    padding: 0.6em;\n    color: white;\n}", ""]);
// Exports
module.exports = exports;
